export default "__VITE_ASSET__DYN00IL$__"